import { Component, Input } from '@angular/core';
import { cn } from '../../../utils/utils';

/** Loading ring in currentColor. `size` is in rem (1 = 16px). */
@Component({
  selector: 'app-loading-spinner',
  standalone: true,
  imports: [],
  templateUrl: './loading-spinner.component.html',
  styleUrl: './loading-spinner.component.css',
})
export class LoadingSpinnerComponent {
  @Input() size: number = 1;
  @Input() className: string = '';

  merge = cn;
}
